










import { Prop, Component, Vue } from "vue-property-decorator";
import ConstructionEdit from "../components/ConstructionEdit.vue";
import {
  getConstructionEdit,
  saveConstruction
} from "../../api/construction-api";
import ConstructionFormData from "../../models/factories/ConstructionFormData";
import createConstructionOutput from "../../models/factories/createConstructionOutput";

@Component({
  components: {
    ConstructionEdit
  }
})
export default class ConstructionEditPage extends Vue {
  @Prop({ default: 0 }) id!: string;
  construction = createConstructionOutput();

  // get taskTypeOptions(): SelectOption[] {
  //   return this.taskTypes.map(c => ({
  //     text: c.name,
  //     value: c.taskTypeId
  //   }));
  // }

  private async initConstruction() {
    this.construction = await getConstructionEdit(this.id);
  }

  private created() {
    this.initConstruction();
  }

  async ok() {
    await this.save();
    this.goListPage();
  }

  private async save() {
    if (!this.construction) return;
    this.construction.id = this.id;
    const d = ConstructionFormData(this.construction);
    await saveConstruction(d);
  }

  cancel() {
    this.goListPage();
  }

  private goListPage() {
    this.$router.push({ name: "construction-list" });
  }
}
